// Panel: the bordered 12px-radius surface with an optional header row (title · meta · actions). DESIGN §2.
import './panel.css';
import { cx } from './ui.jsx';

// title: 15px/600 heading. meta: muted text after the title. actions: right side of the header (range selector, ⋯).
// sub: a line under the title (e.g. two inline stats). flush: no body padding (tables, lists run edge to edge).
// as: element tag (default 'section'). href turns the whole panel into a link (no interactive children then).
export function Panel({ title, meta, actions, sub, flush, as: Tag = 'section', href, id, class: cls, bodyClass, label, children }) {
  const El = href ? 'a' : Tag;
  return (
    <El class={cx('panel', 'panel-v2', flush && 'is-flush', cls)} href={href} id={id} aria-label={label}>
      {(title || actions) && (
        <header class="panel-header">
          <div class="panel-heading">
            {title && (
              <h2 class="panel-title">
                {title}
                {meta != null && meta !== '' && <span class="panel-meta">{meta}</span>}
              </h2>
            )}
            {sub && <div class="panel-sub">{sub}</div>}
          </div>
          {actions && <div class="panel-actions">{actions}</div>}
        </header>
      )}
      <div class={cx('panel-body', bodyClass)}>{children}</div>
    </El>
  );
}
